import * as React from 'react';
import { Box } from '@mui/material';
import Header from '../components/Header';
import LanguageSwitcher from '../components/LanguageSwitcher';
import Layout from '../components/Layout';
import Intro from '../components/IntroCreatePractices';
import Carousel from '../components/Carousel';
import InstallApp from '../components/InstallApp';
import OpinionsFromUsers from '../components/OpinionsFromUsers';
import BannerScheduleMeeting from '../components/BannerScheduleMeeting';
import Footer from '../components/Footer';
import { useTranslation } from 'react-i18next';
import PracticePlanningInMinutes from '../components/PracticePlanningInMinutes';
import PracticeVideo from '../components/PracticePlanningInMinutes';
import AboutiCoachBasketballSection from '../components/AboutiCoachBasketballSection';
import IntroCreatePlaybooksDragAndDrop from '../components/IntroCreatePlaybooksDragAndDrop';
import PlaybookFeatures from '../components/PlaybookFeatures';
import FAQ from '../components/FAQ';
import CustomizePDFs from '../components/CustomizePDFs';

export default function LandingPage() {
    const { t } = useTranslation();

    const featuresData = [
        {
            gridSize: 6,
            title: t("MoreFeatures02"),
            description: t("MoreFeatures03"),
            link: "/drills-library",
        },
        {
            gridSize: 6,
            title: t("MoreFeatures04"),
            description: t("MoreFeatures05"),
            link: "/plays-library",
        },
        {
            gridSize: 12,
            title: t("MoreFeatures06"),
            description: t("MoreFeatures07"),
            link: "/playbook-creator",
        },
    ];

    return (
        <>
            <Layout>
                <Header />
                <Intro />
                <Carousel />
                <PracticePlanningInMinutes />
                <CustomizePDFs />
                <AboutiCoachBasketballSection />
                <IntroCreatePlaybooksDragAndDrop />
                <PlaybookFeatures />
                <InstallApp />
                <OpinionsFromUsers />
                <BannerScheduleMeeting />
                <FAQ />
                <Footer />
                <LanguageSwitcher />
            </Layout>
        </>
    );
}
